// eventBus.js
import tinyEmitter from 'tiny-emitter'
export const createEventBus = () => new tinyEmitter()
export const instance = createEventBus()

export const events = {
  $on: (...args) => instance.on(...args),
  $once: (...args) => instance.once(...args),
  $off: (...args) => instance.off(...args),
  $emit: (...args) => instance.emit(...args),
}

export default () => events
